/* ==========================================================================
   PeekoraLab - free-shipping bridge + cross-sell  ·  2026-09-03

   WHY THIS EXISTS
   ---------------
   Pulled the last 21 abandoned checkouts. 15 of 21 (71%) contained MagicReveal,
   and 14 of 21 (67%) never reached the CA$65 free-shipping threshold. Five of
   those stalled between CA$59.93 and CA$62.96 - CA$2.04 to CA$5.07 short - and
   nothing in the cart ever told them so.

   The mini cart already has a bundle meter (owned by pk-offer-eligibility-core
   and pk-mini-cart-upgrade), which handles same-product upsell ("add a 2nd book,
   50% off"). This does NOT touch it. It adds a separate, additive free-shipping
   bar plus a cross-CATEGORY rail underneath.

   VARIANT PICKER (fixed 2026-09-03)
   ---------------------------------
   The first version added whichever variant was cheapest. For MagicReveal that
   meant tapping Add silently dropped "Animals Adventure" into the cart, and the
   Complete 4-Book Set was unreachable from the drawer. Nobody should receive a
   book they did not pick. Any product with more than one purchasable variant now
   renders a picker; price and the free-shipping flag update as it changes.

   CURATED PAIRINGS (2026-09-24)
   -----------------------------
   PAIRS below maps "product in the cart / on the page" -> the products that go
   with it, in order, each with a one-line reason shown on the card. Curated
   picks always rank above the generic interest score. Edit PAIRS to change
   what is upsold with what.

   NO MUTATION OBSERVER ON THE CART LIST. The theme has a documented history of
   observer loops between pk-bogo-cart-display and the mini cart. This listens to
   the events the theme already dispatches instead.
   ========================================================================== */
(function () {
  'use strict';
  if (window.pkContextRecommendations) return;
  window.pkContextRecommendations = true;

  var cfgEl = document.getElementById('pk-xs-data');
  if (!cfgEl) return;

  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!CFG || !CFG.products || !CFG.products.length) return;

  var THRESHOLD = Number(CFG.threshold) || 0;
  var busy = false;

  function money(cents) { return new Intl.NumberFormat(CFG.locale || 'en', {style:'currency',currency:CFG.currency || 'CAD'}).format(cents / 100); }
  var fr = String(CFG.locale).indexOf('fr') === 0;
  var rootUrl = (CFG.root || '/').replace(/\/?$/, '/');

  var SCOPE = 'peekorascope-explorer-kids-microscope';
  var SD = '32-gb-sd-card';
  var BOOK = 'peekora-magicreveal-water-coloring-book';
  var MINI = 'microscope-60-120x-lab-handheld-microscope-battery-powered-microscope-with-led-light-kids-science-microscope';

  /* anchor handle -> [[target handle, English reason, French reason], ...] */
  var PAIRS = {};
  PAIRS[SCOPE] = [
    [SD, 'Made for PeekoraScope: saves every photo and video they capture.', 'Conçue pour le PeekoraScope : garde chaque photo et vidéo capturée.'],
    [BOOK, 'Screen-free quiet time after exploring. Just add water, no mess.', 'Un moment calme sans écran après l’exploration. De l’eau, sans dégât.']
  ];
  PAIRS[BOOK] = [
    [SCOPE, 'From colouring animals to seeing real leaves, bugs and coins up close.', 'Du coloriage aux vraies feuilles, insectes et pièces vus de près.'],
    [MINI, 'A pocket microscope for curious minds on the go.', 'Un microscope de poche pour les curieux en déplacement.']
  ];
  PAIRS[SD] = [
    [SCOPE, 'The kids microscope this card is made for.', 'Le microscope pour enfants conçu pour cette carte.']
  ];
  PAIRS[MINI] = [
    [BOOK, 'Mess-free colouring for quiet time. Just add water.', 'Coloriage sans dégât pour les moments calmes. Juste de l’eau.'],
    [SCOPE, 'Step up to 50–1000x with a built-in screen and photo capture.', 'Passez à 50–1000x avec écran intégré et capture photo.']
  ];

  function inCart(cart, handle) {
    return (cart.items || []).some(function (i) {
      return (i.handle || i.product_handle) === handle || (handle === SCOPE && /peekorascope/i.test(i.product_title || '') && /[23]-pack/i.test(i.product_title || ''));
    });
  }

  function eligibleTotal(cart) {
    return typeof cart.items_subtotal_price === 'number'
      ? cart.items_subtotal_price
      : cart.total_price;
  }

  /* Which variant should the picker land on? If there is a shipping gap, the
     cheapest variant that actually closes it - that is the one doing the shopper
     a favour. Otherwise the cheapest. They can change it either way. */
  function defaultVariant(p, gap) {
    var vs = (p.variants || []).slice().sort(function (a, b) { return a.price - b.price; });
    if (!vs.length) return null;
    if (gap > 0) {
      for (var i = 0; i < vs.length; i++) { if (vs[i].price >= gap) return vs[i]; }
    }
    return vs[0];
  }

  function interests(p) {
    var text = [p.handle, p.type].concat(p.tags || []).join(' ').toLowerCase();
    return [
      [/microscope|scope|science|circuit|orbit|stem|buildhaul/, 'discovery'],
      [/color|colour|drawing|doodle|mosaic|art|creative/, 'creative'],
      [/preschool|sorting|matching|language|talk|prismatch|colornest/, 'early-learning'],
      [/travel|portable|water.book|magicreveal|pocket/, 'travel']
    ].filter(function (entry) { return entry[0].test(text); }).map(function (entry) { return entry[1]; });
  }

  /* Curated rank + reason for each target, from the anchors in play. The first
     anchor that pairs with a target wins, so the page product beats the cart. */
  function curated(anchors) {
    var map = {};
    anchors.forEach(function (a, ai) {
      (PAIRS[a.handle] || []).forEach(function (pair, pi) {
        if (map[pair[0]]) return;
        map[pair[0]] = {rank: ai * 10 + pi, why: fr ? pair[2] : pair[1]};
      });
    });
    return map;
  }

  function recommend(cart, gap, pdp) {
    var anchors = CFG.products.filter(function (p) { return inCart(cart, p.handle); });
    if (pdp || !anchors.length) {
      var here = {handle: CFG.current || '', type: CFG.currentType, tags: CFG.currentTags};
      if (pdp) anchors.unshift(here); else anchors.push(here);
    }
    var signals = anchors.reduce(function (all, p) { return all.concat(interests(p)); }, []);
    var picked = curated(anchors);
    function score(p) {
      var result = interests(p).reduce(function (sum, interest) { return sum + (signals.indexOf(interest) >= 0 ? 10 : 0); }, 0);
      if (p.requires) result += 50;
      anchors.forEach(function (a) { if (a.type && a.type === p.type) result += 5; });
      return result;
    }
    function rank(p) { return picked[p.handle] ? picked[p.handle].rank : 9999; }
    return CFG.products.filter(function (p) {
      if (!p.available || !p.variants || !p.variants.length || p.handle === CFG.current || inCart(cart, p.handle)) return false;
      if (p.requires && !inCart(cart, p.requires) && !(pdp && CFG.current === p.requires)) return false;
      return true;
    }).sort(function (a, b) {
      /* 2026-09-22: when the cart is short of free shipping, lead with the
         cheapest item that actually closes the gap - not a CA$90 microscope to
         cover a CA$15 gap. */
      if (!pdp && gap > 0) {
        var ab = a.price >= gap, bb = b.price >= gap;
        if (ab !== bb) return ab ? -1 : 1;
        if (ab && bb && a.price !== b.price) return a.price - b.price;
      }
      return rank(a) - rank(b) || score(b) - score(a) || Math.abs(a.price - gap) - Math.abs(b.price - gap) || a.handle.localeCompare(b.handle);
    }).slice(0, pdp ? 10 : 6).map(function (p) {
      return picked[p.handle] ? Object.assign({}, p, {why: picked[p.handle].why}) : p;
    });
  }

  function carousel(list, controls) {
    if (!list || !controls) return;
    if (list.pkUpdateControls) { requestAnimationFrame(list.pkUpdateControls); return; }
    ['previous', 'next'].forEach(function (direction) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'pk-rec-arrow';
      button.textContent = direction === 'previous' ? '←' : '→';
      button.setAttribute('aria-label', CFG.labels[direction]);
      button.addEventListener('click', function () {
        list.scrollBy({left: (direction === 'previous' ? -1 : 1) * list.clientWidth * 0.85, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      });
      controls.appendChild(button);
    });
    function update() {
      var overflow = list.scrollWidth > list.clientWidth + 2;
      controls.hidden = !overflow;
      controls.children[0].disabled = list.scrollLeft <= 1;
      controls.children[1].disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
    }
    list.pkUpdateControls = update;
    list.addEventListener('scroll', update, {passive:true});
    window.addEventListener('resize', update);
    if (window.ResizeObserver) new ResizeObserver(update).observe(list);
    requestAnimationFrame(update);
  }

  function renderRelated(cart) {
    var wrap = document.querySelector('[data-pk-related]');
    if (!wrap) return;
    var list = wrap.querySelector('[data-pk-related-list]');
    var picks = recommend(cart, 0, true);
    var signature = picks.map(function (p) { return p.handle; }).join('|');
    if (wrap.dataset.signature === signature) return;
    wrap.dataset.signature = signature;
    list.replaceChildren();
    picks.forEach(function (p) {
      var article = document.createElement('article');
      article.className = 'pk-discovery__card';
      var link = document.createElement('a');
      link.href = p.url;
      var img = document.createElement('img');
      img.src = p.image; img.alt = p.title; img.width = 480; img.height = 480; img.loading = 'lazy';
      var title = document.createElement('h3'); title.textContent = p.title;
      link.append(img, title);
      if (p.why) { var why = document.createElement('p'); why.className = 'pk-xs__why'; why.textContent = p.why; link.appendChild(why); }
      var price = document.createElement('p'); price.textContent = money(p.price);
      article.append(link, price); list.appendChild(article);
    });
    wrap.hidden = !picks.length;
    carousel(list, wrap.querySelector('[data-pk-related-controls]'));
  }

  function buildShell() {
    var existing = document.getElementById('pk-xs');
    if (existing) return existing;
    var host = document.querySelector('[data-pkmc-items]');
    if (!host || !host.parentNode) return null;

    var wrap = document.createElement('div');
    wrap.id = 'pk-xs';
    wrap.className = 'pk-xs';
    wrap.innerHTML =
      '<div class="pk-xs__ship" data-xs-ship hidden>' +
        '<p class="pk-xs__ship-msg" data-xs-ship-msg role="status"></p>' +
        '<div class="pk-xs__bar"><span class="pk-xs__bar-fill" data-xs-bar></span></div>' +
      '</div>' +
      '<div class="pk-xs__rec" data-xs-rec hidden>' +
        '<p class="pk-xs__rec-head" data-xs-rec-head>Goes well with</p>' +
        '<div class="pk-rec-controls" data-xs-controls></div><div class="pk-xs__list" data-xs-list tabindex="0" role="region"></div>' +
      '</div>';
    host.parentNode.insertBefore(wrap, host.nextSibling);
    return wrap;
  }

  function card(p, gap, index) {
    var chosen = defaultVariant(p, gap);
    if (!chosen) return null;

    var el = document.createElement('div');
    el.className = 'pk-xs__card';

    var img = document.createElement('img');
    img.className = 'pk-xs__img';
    img.src = p.image; img.alt = '';
    img.width = 52; img.height = 52; img.loading = 'lazy';

    var body = document.createElement('div');
    body.className = 'pk-xs__body';

    var title = document.createElement('a');
    title.href = p.url;
    title.className = 'pk-xs__title';
    title.textContent = p.title;
    body.appendChild(title);

    if (p.why) {
      var why = document.createElement('p');
      why.className = 'pk-xs__why';
      why.textContent = p.why;
      body.appendChild(why);
    }

    var price = document.createElement('p');
    price.className = 'pk-xs__price';
    var amt = document.createElement('span');
    var flag = document.createElement('em');
    flag.className = 'pk-xs__flag';
    flag.textContent = (fr ? 'livraison gratuite débloquée' : 'unlocks free shipping');
    price.appendChild(amt);

    var btn = document.createElement('button');
    btn.className = 'pk-xs__add';
    btn.type = 'button';
    btn.textContent = fr ? 'Ajouter' : 'Add';

    /* Reflects the currently chosen variant everywhere at once. */
    function sync(v) {
      chosen = v;
      amt.textContent = money(v.price);
      var bridges = gap > 0 && v.price >= gap;
      if (bridges && !flag.parentNode) price.appendChild(flag);
      if (!bridges && flag.parentNode) flag.parentNode.removeChild(flag);
      btn.setAttribute('data-xs-add', v.id);
      btn.setAttribute('aria-label', 'Add ' + p.title + ', ' + v.title + ', ' + money(v.price) + ', to cart');
    }

    if (p.variants.length > 1) {
      var selId = 'pk-xs-v-' + index;
      var label = document.createElement('label');
      label.className = 'pk-xs__vlabel';
      label.setAttribute('for', selId);
      label.textContent = (fr ? 'Choisir une option' : 'Choose option');

      var sel = document.createElement('select');
      sel.className = 'pk-xs__vselect';
      sel.id = selId;

      p.variants.slice().sort(function (a, b) { return a.price - b.price; }).forEach(function (v) {
        var o = document.createElement('option');
        o.value = String(v.id);
        o.textContent = v.title + '  ' + money(v.price);
        sel.appendChild(o);
      });
      sel.value = String(chosen.id);

      sel.addEventListener('change', function () {
        var v = p.variants.filter(function (x) { return String(x.id) === sel.value; })[0];
        if (v) sync(v);
      });

      body.appendChild(label);
      body.appendChild(sel);
    }

    body.appendChild(price);
    sync(chosen);

    el.appendChild(img);
    el.appendChild(body);
    el.appendChild(btn);
    return el;
  }

  function render(cart) {
    if (!cart) return;
    renderRelated(cart);
    var wrap = buildShell();
    if (!wrap) return;

    var total = eligibleTotal(cart);
    var gap = Math.max(0, THRESHOLD - total);
    var empty = !cart.items || cart.items.length === 0;

    var ship = wrap.querySelector('[data-xs-ship]');
    var msg = wrap.querySelector('[data-xs-ship-msg]');
    var bar = wrap.querySelector('[data-xs-bar]');

    if (empty || !THRESHOLD) {
      ship.hidden = true;
    } else {
      ship.hidden = false;
      bar.style.width = Math.min(100, Math.round((total / THRESHOLD) * 100)) + '%';
      ship.classList.toggle('is-done', gap === 0);
      var nextMsg = gap === 0 ? (fr ? 'Livraison gratuite débloquée' : 'Free shipping unlocked') : money(gap) + (fr ? ' avant la livraison gratuite' : ' away from free shipping');
      if (msg.textContent !== nextMsg) msg.textContent = nextMsg;
    }

    var rec = wrap.querySelector('[data-xs-rec]');
    var list = wrap.querySelector('[data-xs-list]');
    var head = wrap.querySelector('[data-xs-rec-head]');
    var picks = empty ? [] : recommend(cart, gap);

    if (!picks.length) { rec.hidden = true; return; }

    var sig = picks.map(function (p) { return p.handle; }).join('-') + ':' + gap;
    if (rec.dataset.sig === sig) { rec.hidden = false; return; }
    rec.dataset.sig = sig;

    /* The bar above already says how far away free shipping is - do not repeat
       the amount here. */
    head.textContent = (gap > 0 && picks[0].price >= gap)
      ? (fr ? 'Complétez votre commande' : 'Complete your order')
      : (fr ? 'À découvrir aussi' : 'Goes well with');

    list.replaceChildren();
    picks.forEach(function (p, i) {
      var c = card(p, gap, i);
      if (c) list.appendChild(c);
    });
    rec.hidden = false;
    list.setAttribute('aria-label', CFG.labels.related);
    carousel(list, wrap.querySelector('[data-xs-controls]'));
  }

  function add(id, btn) {
    if (busy || !id) return;
    busy = true;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = (fr ? 'Ajout…' : 'Adding');

    fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        btn.textContent = (fr ? 'Ajouté' : 'Added');
        document.dispatchEvent(new CustomEvent('peekora:cart:changed', { detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('peekora:cart:updated', { detail: { open: true } }));
        render(cart);
      })
      .catch(function () { btn.textContent = (fr ? 'Réessayer' : 'Try again'); })
      .then(function () {
        busy = false;
        setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 1400);
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-xs-add]');
    if (!btn) return;
    e.preventDefault();
    add(btn.getAttribute('data-xs-add'), btn);
  });

  document.addEventListener('peekora:offer:rendered', function (e) {
    if (e.detail && e.detail.cart) render(e.detail.cart);
  });
  document.addEventListener('peekora:cart:changed', function (e) {
    if (e.detail && e.detail.cart) render(e.detail.cart);
  });

  function boot() {
    renderRelated({items: []});
    fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
}());